// extracted by mini-css-extract-plugin
export var button = "_dj-0";
export var donut = "_dj-1";
export var donutFill = "_dj-3";
export var donutTrack = "_dj-2";